/**
 * Sonidos de la pantalla de Mesas (add-on Pedidos QR).
 *
 * Van sintetizados en vez de mp3 por dos razones:
 *
 * 1. Los dos mp3 que existian (notificacion_pedido_nuevo, notificacion_retiro)
 *    ya los usa usePedidosKDS, o sea el KDS y el TPV. Si Mesas usara los
 *    mismos, el personal escucha un chime y no sabe si es la caja o una mesa.
 *    Los dos que quedaban libres no servian: alarma_pago_pendiente son casi 5
 *    segundos de sirena y en un local suena a emergencia, no a "mesa 4 pide la
 *    cuenta".
 *
 * 2. Asi la diferencia entre las dos alarmas no depende del timbre (que se
 *    pierde con ruido de local) sino del PATRON, que se reconoce igual:
 *      pedido nuevo  -> dos notas que SUBEN
 *      piden cuenta  -> tres notas que BAJAN
 *
 * El timbre es una campana suave: seno con un armonico a la octava bajito y
 * caida exponencial. Es lo mismo que hace un timbre de hotel o un xilofono, no
 * un buzzer.
 */

let ctx = null;

const getCtx = () => {
    if (!ctx) {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return null;
        ctx = new AudioCtx();
    }
    // El navegador deja el contexto suspendido hasta que hay un clic. Se
    // reintenta en cada alarma: apenas el garzon toque la pantalla, suena.
    if (ctx.state === 'suspended') ctx.resume().catch(() => { });
    return ctx;
};

/**
 * Una nota tipo campana.
 * @param {number} frecuencia Hz
 * @param {number} retraso segundos desde ahora
 * @param {number} duracion segundos que tarda en apagarse
 * @param {number} volumen 0..1
 */
const nota = (audio, frecuencia, retraso, duracion, volumen) => {
    const t0 = audio.currentTime + retraso;

    const ganancia = audio.createGain();
    ganancia.connect(audio.destination);

    // Ataque corto pero no instantaneo: a 0 el oscilador chasquea al arrancar.
    ganancia.gain.setValueAtTime(0.0001, t0);
    ganancia.gain.exponentialRampToValueAtTime(volumen, t0 + 0.012);
    ganancia.gain.exponentialRampToValueAtTime(0.0001, t0 + duracion);

    // Fundamental
    const osc = audio.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(frecuencia, t0);
    osc.connect(ganancia);
    osc.start(t0);
    osc.stop(t0 + duracion + 0.05);

    // Armonico a la octava, bajito: le da cuerpo de campana en vez de pito.
    const brillo = audio.createOscillator();
    const gBrillo = audio.createGain();
    brillo.type = 'sine';
    brillo.frequency.setValueAtTime(frecuencia * 2, t0);
    gBrillo.gain.setValueAtTime(0.0001, t0);
    gBrillo.gain.exponentialRampToValueAtTime(volumen * 0.25, t0 + 0.012);
    gBrillo.gain.exponentialRampToValueAtTime(0.0001, t0 + duracion * 0.6);
    brillo.connect(gBrillo);
    gBrillo.connect(audio.destination);
    brillo.start(t0);
    brillo.stop(t0 + duracion + 0.05);
};

// Notas reales para que el acorde no suene desafinado:
// A5 880, D6 1174.66, B5 987.77, G5 783.99
const SUBE = [880.00, 1174.66];              // pedido nuevo
const BAJA = [1174.66, 987.77, 783.99];      // piden la cuenta

/** Pedido nuevo por QR: dos notas que suben. Corto y amable. */
export const sonarPedidoNuevo = () => {
    const audio = getCtx();
    if (!audio) return;
    SUBE.forEach((f, i) => nota(audio, f, i * 0.13, 0.55, 0.16));
};

/** El cliente pide la cuenta: tres notas que bajan. Mas presente, sin ser alarma. */
export const sonarCuentaSolicitada = () => {
    const audio = getCtx();
    if (!audio) return;
    BAJA.forEach((f, i) => nota(audio, f, i * 0.17, 0.75, 0.18));
};

/** Para probar los dos seguidos desde la consola sin esperar un pedido real. */
export const probarSonidos = () => {
    sonarPedidoNuevo();
    setTimeout(sonarCuentaSolicitada, 1600);
};
